export default __webpack_public_path__ + "704d8add27e0930f47446e5a2b249980.svg";